var endpointMap = {
	de: {
		RTTVWidgetTranslations: "translation-de.json"
	},
	"de-DE": {
		RTTVWidgetTranslations: "translation-de.json"
	},
	en: {
		RTTVWidgetTranslations: "translation-en.json"
	},
	"en-GB": {
		RTTVWidgetTranslations: "translation-en.json"
	},
	"en-US": {
		RTTVWidgetTranslations: "translation-en.json"
	},
	es: {
		RTTVWidgetTranslations: "translation-es.json"
	},
	"es-ES": {
		RTTVWidgetTranslations: "translation-es.json"
	},
	fr: {
		RTTVWidgetTranslations: "translation-fr.json"
	},
	"fr-FR": {
		RTTVWidgetTranslations: "translation-fr.json"
	},
	hi: {
		RTTVWidgetTranslations: "translation-hi.json"
	},
	"hi-IN": {
		RTTVWidgetTranslations: "translation-hi.json"
	},
	it: {
		RTTVWidgetTranslations: "translation-it.json"
	},
	"it-IT": {
		RTTVWidgetTranslations: "translation-it.json"
	},
	ja: {
		RTTVWidgetTranslations: "translation-ja.json"
	},
	"ja-JP": {
		RTTVWidgetTranslations: "translation-ja.json"
	},
	ko: {
		RTTVWidgetTranslations: "translation-ko.json"
	},
	"ko-KR": {
		RTTVWidgetTranslations: "translation-ko.json"
	},
	pt: {
		RTTVWidgetTranslations: "translation-pt.json"
	},
	"pt-BR": {
		RTTVWidgetTranslations: "translation-pt.json"
	},
	ta: {
		RTTVWidgetTranslations: "translation-ta.json"
	},
	"ta-IN": {
		RTTVWidgetTranslations: "translation-ta.json"
	},
	th: {
		RTTVWidgetTranslations: "translation-th.json"
	},
	"th-TH": {
		RTTVWidgetTranslations: "translation-th.json"
	},
	und: {
		RTTVWidgetTranslations: "translation.json"
	},
	vi: {
		RTTVWidgetTranslations: "translation-vi.json"
	},
	"vi-VN": {
		RTTVWidgetTranslations: "translation-vi.json"
	},
	zh: {
		RTTVWidgetTranslations: "translation-zh.json"
	},
	"zh-CN": {
		RTTVWidgetTranslations: "translation-zh.json"
	},
	"zh-TW": {
		RTTVWidgetTranslations: "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
